import { render } from "./produtos.vue?vue&type=template&id=74b9f013&scoped=true"
import script from "./produtos.vue?vue&type=script&lang=js"
export * from "./produtos.vue?vue&type=script&lang=js"

import "./produtos.vue?vue&type=style&index=0&id=74b9f013&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b9f013"]])

export default __exports__